pageTransition.goto = {

	type : null,

	links : {
		elems : null,
		array : []
	},

	onReInit(){
		this.onDestroy();
		this.onInit();
	},

	onInit(){
		this.prop = pageTransition;
		this.links.elems = this.prop.local.querySelectorAll('.js-goto');
		for (let i = 0; i < this.links.elems.length; i++) {
			const el = this.links.elems[i];
			const atag = el.querySelector('.js-goto-a') ? el.querySelector('.js-goto-a') : el;
			if( atag ){
				const href = atag.getAttribute('href');
				const type = el.dataset.transition;
				const key = el.dataset.key;
				const postId = el.dataset.postId;
				this.links.array.push({
					el     : el,
					atag   : atag,
					href   : href,
					type   : type,
					key    : key,
					postId : postId,
					click  : null,
					mouseenter : null,
					prefetch : false,
				});
			}
		}
		this.addEvents();
	},
	
	addEvents(){
		this.links.array.forEach( (v,i) =>{
			v.click = (e) =>{
				e.preventDefault();
				this.type = v.type;
				this.onGoto( v );
			}
			v.mouseenter = () =>{
				if( !v.prefetch ){
					v.prefetch = true;
					barba.prefetch( v.href );
				}
			}
			v.el.addEventListener('click', v.click);
			v.el.addEventListener('mouseenter', v.mouseenter);
		});
	},

	onDestroy(){
		this.type = null;
		this.links.array.forEach( (v,i) =>{
			v.el.removeEventListener('click', v.click);
			v.el.removeEventListener('mouseenter', v.mouseenter);
			v.click = null;
			v.mouseenter = null;
		});
		this.links.array = [];
	},

	onGoto( v ){
		switch( v.type ){
			case 'archive-to-single':
				this.onArchiveToSingle( v );
			break;
			case 'single-to-single':
				this.onSingleToSingle( v );
			break;
			default:
				barba.go( v.href );
			break;
		}
	},

	onArchiveToSingle( v ){
		barba.go( v.href );
	},

	onSingleToSingle( v ){
		barba.go( v.href );
	},

	onLeave( data, done ){
	},

}



















